document.addEventListener('click', function(e) {
  const btn = e.target.closest('[data-like-concept]')
  if (!btn) return
  e.preventDefault()

  const url = btn.getAttribute('data-url')
  if (!url) return

  btn.disabled = true

  fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
      'Accept': 'application/json'
    }
  })
    .then(r => r.json())
    .then(data => {
      const icon = btn.querySelector('i')
      const countEl = btn.querySelector('.like-count')
      if (data.favorited) {
        btn.classList.add('selected')
        if (icon) icon.classList.remove('far'), icon.classList.add('fas')
      } else {
        btn.classList.remove('selected')
        if (icon) icon.classList.remove('fas'), icon.classList.add('far')
      }
      if (countEl && typeof data.count === 'number') {
        countEl.textContent = data.count
      }
    })
    .catch(err => console.error(err))
    .finally(() => { btn.disabled = false })
})


